(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sidefill-card-buy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target.closest('.sf-card-buy__variant-input');
    if (!input) return;
    const card = input.closest('product-card');
    const picker = input.closest('.sf-card-buy');
    const image = card?.querySelector('.product-card__image--primary');
    const price = card?.querySelector('[data-sidefill-card-price]');
    if (price && input.dataset.price) price.textContent = input.dataset.price;
    if (image && input.dataset.image) {
      image.src = input.dataset.image;
      image.removeAttribute('srcset');
    }
    if (card && picker?.dataset.productUrl) {
      const variantUrl = new URL(picker.dataset.productUrl, window.location.origin);
      variantUrl.searchParams.set('variant', input.value);
      card.querySelectorAll('.product-card__media, .product-title').forEach((link) => {
        link.href = `${variantUrl.pathname}${variantUrl.search}`;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sidefill-volume-tiers"] && !Shopify.designMode) return;
  try {
    class SidefillVolumeTiers extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.form = document.getElementById(this.dataset.formId);
      this.input = this.form?.querySelector('[name="quantity"]') || document.querySelector(`[name="quantity"][form="${CSS.escape(this.dataset.formId)}"]`);
      if (!this.input) {
        requestAnimationFrame(() => this.connectedCallback());
        return;
      }
      this.dataset.initialized = 'true';

      this.mixOpen = false;
      this.mixWrap = this.querySelector('.sf-color-mix');
      this.mixPanel = this.querySelector('[data-color-mix-panel]');
      this.mixToggle = this.querySelector('[data-color-mix-toggle]');

      this.onClick = (event) => {
        const mixToggle = event.target.closest('[data-color-mix-toggle]');
        if (mixToggle) {
          this.toggleMix();
          return;
        }
        const stepButton = event.target.closest('[data-mix-plus], [data-mix-minus]');
        if (stepButton) {
          this.stepColor(stepButton.closest('[data-color-row]'), stepButton.hasAttribute('data-mix-plus') ? 1 : -1);
          return;
        }
        const button = event.target.closest('[data-volume-tier]');
        if (!button) return;
        const quantity = Number(button.dataset.volumeTier || 1);
        if (this.mixOpen) {
          this.fillMixToTotal(quantity);
          return;
        }
        this.input.value = String(quantity);
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.render();
      };
      this.onQuantityChange = () => this.render();
      this.onQuantityClick = () => requestAnimationFrame(() => this.render());
      // Fallback submit handling for contexts without sidefill-smart-bundle (e.g. quick buy).
      this.onSubmit = (event) => this.onFormSubmit(event);
      this.addEventListener('click', this.onClick);
      this.input.addEventListener('input', this.onQuantityChange);
      this.input.addEventListener('change', this.onQuantityChange);
      this.input.closest('quantity-selector')?.addEventListener('click', this.onQuantityClick);
      this.form?.addEventListener('submit', this.onSubmit, true);
      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.input?.removeEventListener('input', this.onQuantityChange);
      this.input?.removeEventListener('change', this.onQuantityChange);
      this.input?.closest('quantity-selector')?.removeEventListener('click', this.onQuantityClick);
      this.form?.removeEventListener('submit', this.onSubmit, true);
    }

    formatMoney(cents) {
      return `CHF ${(Number(cents || 0) / 100).toFixed(2)}`;
    }

    get colorRows() {
      return Array.from(this.querySelectorAll('[data-color-row]'));
    }

    getFormVariantId() {
      return Number(this.form ? new FormData(this.form).get('id') : 0);
    }

    toggleMix() {
      this.mixOpen ? this.closeMix() : this.openMix();
    }

    openMix() {
      this.mixOpen = true;
      // Seed the distribution with the color and quantity currently selected in the native flow.
      const formVariantId = this.getFormVariantId();
      const quantity = Math.max(1, Number(this.input?.value || 1));
      this.colorRows.forEach((row) => {
        const isCurrent = Number(row.dataset.variantId) === formVariantId && !row.classList.contains('is-unavailable');
        this.setRowCount(row, isCurrent ? quantity : 0);
      });
      if (!this.colorRows.some((row) => this.rowCount(row) > 0)) {
        const firstAvailable = this.colorRows.find((row) => !row.classList.contains('is-unavailable'));
        if (firstAvailable) this.setRowCount(firstAvailable, quantity);
      }
      this.classList.add('mix-open');
      this.mixWrap?.classList.add('is-open');
      if (this.mixPanel) this.mixPanel.hidden = false;
      this.mixToggle?.setAttribute('aria-expanded', 'true');
      this.syncMix();
      this.scrollAtcIntoView();
    }

    // After opening the panel, keep the add-to-cart button in view: scroll down just enough,
    // but never push the panel header out of the viewport.
    scrollAtcIntoView() {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const submitButton = Array.from(this.form?.elements || []).find((el) => el.type === 'submit' && el.offsetParent);
        if (!submitButton || !this.mixToggle) return;
        const overshoot = submitButton.getBoundingClientRect().bottom + 14 - window.innerHeight;
        if (overshoot <= 0) return;
        const delta = Math.min(overshoot, Math.max(0, this.mixToggle.getBoundingClientRect().top - 70));
        if (delta > 0) window.scrollBy({ top: delta, behavior: 'smooth' });
      }));
    }

    closeMix() {
      this.mixOpen = false;
      this.classList.remove('mix-open');
      this.mixWrap?.classList.remove('is-open');
      if (this.mixPanel) this.mixPanel.hidden = true;
      this.mixToggle?.setAttribute('aria-expanded', 'false');
      // Back to single-color mode: the form variant keeps the total quantity.
      this.input.value = String(Math.max(1, this.mixTotal()));
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.render();
    }

    rowCount(row) {
      return Number(row.querySelector('[data-mix-count]')?.dataset.count || 0);
    }

    setRowCount(row, count) {
      const node = row.querySelector('[data-mix-count]');
      if (!node) return;
      node.dataset.count = String(count);
      node.textContent = String(count);
    }

    mixTotal() {
      return this.colorRows.reduce((sum, row) => sum + this.rowCount(row), 0);
    }

    stepColor(row, delta) {
      if (!row) return;
      const next = this.rowCount(row) + delta;
      if (next < 0) return;
      if (delta < 0 && this.mixTotal() <= 1) return;
      this.setRowCount(row, next);
      this.syncMix();
    }

    fillMixToTotal(target) {
      // Tier presets while mixing: top up (or reduce) the main selected color so the set reaches the tier size.
      const formVariantId = this.getFormVariantId();
      let anchor = this.colorRows.find((row) => Number(row.dataset.variantId) === formVariantId && !row.classList.contains('is-unavailable'));
      anchor ||= this.colorRows.find((row) => this.rowCount(row) > 0) || this.colorRows.find((row) => !row.classList.contains('is-unavailable'));
      if (!anchor) return;
      const others = this.colorRows.filter((row) => row !== anchor).reduce((sum, row) => sum + this.rowCount(row), 0);
      this.setRowCount(anchor, Math.max(target - others, others >= target ? this.rowCount(anchor) : 0));
      this.syncMix();
    }

    syncMix() {
      const total = Math.max(1, this.mixTotal());
      this.colorRows.forEach((row) => {
        const minus = row.querySelector('[data-mix-minus]');
        if (minus) minus.disabled = this.rowCount(row) === 0 || this.mixTotal() <= 1;
      });
      this.input.value = String(total);
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.renderMixSummary();
      this.render();
    }

    renderMixSummary() {
      const summary = this.querySelector('[data-color-mix-summary]');
      if (!summary) return;
      const threshold = Number(this.dataset.discountThreshold || 3);
      const percent = Number(this.dataset.discountPercent || 20);
      const parts = [];
      let originalCents = 0;
      this.colorRows.forEach((row) => {
        const count = this.rowCount(row);
        if (count === 0) return;
        parts.push(`${count}× ${row.dataset.colorLabel}`);
        originalCents += count * Number(row.dataset.price || 0);
      });
      const total = this.mixTotal();
      const discounted = Math.round(originalCents * (100 - percent) / 100);
      const savingCents = originalCents - discounted;
      const label = total === 1 ? '1 Flasche' : `${total} Flaschen`;
      const mixLabel = parts.length > 1 ? ` (${parts.join(', ')})` : '';

      if (total >= threshold) {
        summary.innerHTML = `<strong>${label}</strong>${mixLabel} · <s>${this.formatMoney(originalCents)}</s> <strong>${this.formatMoney(discounted)}</strong><br><span class="is-saving">${percent} % Rabatt · ${this.formatMoney(savingCents)} werden im Warenkorb automatisch abgezogen.</span>`;
      } else if (total === threshold - 1) {
        const nextOriginal = originalCents + Number(this.colorRows.find((row) => !row.classList.contains('is-unavailable'))?.dataset.price || 0);
        const nextSaving = nextOriginal - Math.round(nextOriginal * (100 - percent) / 100);
        summary.innerHTML = `<strong>${label}</strong>${mixLabel} · ${this.formatMoney(originalCents)}<br><span class="is-nudge">Noch 1 Flasche, dann sparst du ${this.formatMoney(nextSaving)} (−${percent} %).</span>`;
      } else {
        summary.innerHTML = `<strong>${label}</strong>${mixLabel} · ${this.formatMoney(originalCents)} · Ab ${threshold} Flaschen sparst du ${percent} %.`;
      }
    }

    // Returns the mixed set as cart items when the native single-variant submit would be wrong, otherwise null.
    getMixItems() {
      if (!this.mixOpen) return null;
      const items = this.colorRows
        .filter((row) => this.rowCount(row) > 0)
        .map((row) => ({ id: Number(row.dataset.variantId), quantity: this.rowCount(row) }));
      if (!items.length) return null;
      if (items.length === 1 && items[0].id === this.getFormVariantId()) return null;
      return items;
    }

    async onFormSubmit(event) {
      const items = this.getMixItems();
      if (!items) return;
      // sidefill-smart-bundle owns the submit when present (it merges the mix with the accessory add-ons).
      if (document.querySelector(`sidefill-smart-bundle[data-form-id="${CSS.escape(this.dataset.formId)}"]`)) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const errorNode = this.querySelector('[data-color-mix-error]');
      if (errorNode) errorNode.hidden = true;
      const submitButtons = Array.from(this.form.elements).filter((element) => element.type === 'submit');
      submitButtons.forEach((button) => {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
        });
        const responseJson = await response.json();
        if (!response.ok) throw new Error(responseJson.description || 'Die Auswahl konnte nicht hinzugefügt werden.');

        if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        // Automatic quantity discounts are calculated after the add request, so refetch the cart and sections.
        const root = String(Shopify.routes.root || '/');
        const [cart, freshSections] = await Promise.all([
          fetch(`${root}cart.js`, { cache: 'no-store' }).then((result) => result.json()),
          Promise.all(sections.map(async (sectionId) => {
            const result = await fetch(`${root}?section_id=${encodeURIComponent(sectionId)}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
            if (!result.ok) throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
            return [sectionId, await result.text()];
          })).then(Object.fromEntries)
        ]);
        cart.sections = freshSections;
        this.form.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: { items: responseJson.items || [], cart, onSuccessDo: 'force_open_drawer' }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart }
        }));
      } catch (error) {
        if (errorNode) {
          errorNode.textContent = error.message;
          errorNode.hidden = false;
        }
        this.form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: error.message } }));
      } finally {
        submitButtons.forEach((button) => {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }

    render() {
      const quantity = Math.max(1, Number(this.input?.value || 1));
      this.querySelectorAll('[data-volume-tier]').forEach((button) => {
        const selected = Number(button.dataset.volumeTier) === quantity;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      const status = this.querySelector('[data-volume-tier-status]');
      if (!status) return;
      if (quantity >= 3) status.textContent = `${quantity} Flaschen · 20 % Mengenrabatt wird im Warenkorb automatisch abgezogen.`;
      else if (quantity === 1) status.textContent = '1 Flasche ausgewählt.';
      else status.textContent = `${quantity} Flaschen ausgewählt · ab 3 Flaschen sparst du 20 %.`;
    }
  }

  if (!customElements.get('sidefill-volume-tiers')) {
    customElements.define('sidefill-volume-tiers', SidefillVolumeTiers);
  }
  } catch(e) { console.error(e); }
})();

})();
